import { AccountExtraitTransactionDetailsProviderState } from './types';

const initialAccountExtraitTransactionListFilters = { pageSize: 10, pageOffset: 0 };

const defaultAccountExtraitTransactionDetailsProviderState: AccountExtraitTransactionDetailsProviderState = {
  accountExtraitTransactionDetailsData: null,
  isLoadingAccountExtraitTransactionDetails: false,
  selectedAccountExtraitTransaction: null,
  checkAuthorizationData: null,
  isLoadingCheckAuthorization: false,
  onCheckAuthorizationMutation: () => {},
  onSelectAccountExtraitTransaction: (transactionId?: string) => {},
  resetSelectedAccountExtraitTransaction: () => {},
  onAccountExtraitDetailsMutation: () => {},
};

export { defaultAccountExtraitTransactionDetailsProviderState, initialAccountExtraitTransactionListFilters };
